export var buttonSizesWithDeprecationWarning = {
  /**
   * @deprecated
   * Use buttonSize="sm" instead.
   */
  sm: 'sm',
  /**
   * @deprecated
   * Use buttonSize="md" instead.
   */
  md: 'md',
  /**
   * @deprecated
   * Use buttonSize="lg" instead.
   */
  lg: 'lg'
};